/**
 * @description 貼心推薦/我的收藏在首頁及我的收藏顯示項目數
 */
export enum RecommandCount {
  /** 全部顯示 */
  All = 0,
  /** 顯示 2 個 */
  Home = 2,
  /** 顯示 6 個 */
  MyFavorite = 6
}

/**
 * @description 熱門活動顯示圖片張數用
 */
export enum ActivityCount {
  /** 首頁 */
  Home = 9,
  /** 旅遊險首頁 */
  Travel = 9,
  /** 車險首頁 */
  Car = 9,
  /** 機車險首頁 */
  Moto = 9
}

/**
 * @description 汽機車險投保規則顯示欄位數
*/
export enum InsureRuleCount {
  /** 預設 9 欄 */
  Default = 9,
  /** 車體險 8 欄 */
  CarBody = 8
}

/**
 * @description 最新消息顯示消息數
*/
export enum NewsCount {
  /** 預設 3 則 */
  Default = 3
}

/**
 * @description 優惠列表顯示數
*/
export enum PromotionCount {
  /** 預設 3 則 */
  Default = 3
}

/**
 * @description 加值服務顯示數
*/
export enum ValueAddCount {
  /** 預設 3 則 */
  Default = 3
}

/**
 * @description 投保作業廠牌顯示數
*/
export enum VehicleMarkCount {
  /** 預設 7 則 */
  Default = 7
}
